import React from 'react';
import PropTypes from 'prop-types';

// components
import Icon from '../Icon';
import { MessageWrapper, IconWrapper, TextWrapper } from './styled';

function Message({ type, text }) {
    return (
        <MessageWrapper type={type}>
            <IconWrapper type={type}>
                {type === 'success' && <Icon name="done" />}
                {type === 'error' && <Icon name="clear" />}
            </IconWrapper>
            <TextWrapper>{text}</TextWrapper>
        </MessageWrapper>
    );
}

Message.propTypes = {
    type: PropTypes.oneOf(['success', 'error']).isRequired,
    text: PropTypes.string.isRequired,
};

export default Message;
